module.exports = __webpack_public_path__ + "img/1440.6daa80b0.jpg";